import React, { useContext, createContext } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import ContractIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandIcon from '@material-ui/icons/ExpandMoreOutlined';
import styles from '../collapsable-panel/collapsablePanel.module.css';

const PanelContext = createContext();
const small = [24, 0, 0];
const regular = [36, 3, 1];

const ControlledPanel = ({ open, disabled, onClick, size, children }) => {
	const [fontSize, openElev, closeElev] = size === 'small' ? small : regular;

	return (
		<PanelContext.Provider value={open}>
			<Paper elevation={open ? openElev : closeElev } className={styles.container}>
				{!disabled && (
					<div onClick={onClick} role="button" aria-label={open ? "Collapse this panel" : "Expand this panel"} className={styles.button} tabIndex="0" onKeyPress={onInputKeyPressHandler}>
						{open ? <ContractIcon style={{ fontSize }} /> : <ExpandIcon style={{ fontSize }} />}
					</div>
				)}
				{children}
			</Paper>
		</PanelContext.Provider>
	);
};
ControlledPanel.propTypes = {
	open: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
	onClick: PropTypes.func.isRequired,
	size: PropTypes.string,
	children: PropTypes.node.isRequired
};

const onInputKeyPressHandler = e => {
	if (e.nativeEvent.key === ' ') {
		e.currentTarget.click();
	}
};

const Open = ({ children }) => {
	const isOpen = useContext(PanelContext);
	return isOpen ? children : null;
};

const Closed = ({ children }) => {
	const isOpen = useContext(PanelContext);
	return isOpen ? null : children;
};

ControlledPanel.Open = Open;
ControlledPanel.Closed = Closed;

export default ControlledPanel;
